module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', _vm._b({
    staticClass: "select_common",
    attrs: {
      "maxTagCount": 1,
      "maxTagTextLength": 10
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.myDefaultVal),
      callback: function($$v) {
        _vm.myDefaultVal = $$v
      },
      expression: "myDefaultVal"
    }
  }, 'el-select', _vm.$attrs, false), [(_vm.list) ? _vm._l((_vm.list), function(item) {
    return _c('el-option', {
      key: item[_vm.keys.value],
      attrs: {
        "value": item[_vm.keys.value],
        "label": item[_vm.keys.label]
      }
    })
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-641bf906"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectCommon.vue
// module id = 1128
// module chunks = 1